<template>
	<div class="fragment">
		<span v-if="!isFirst" class="operator">{{ bool }} </span>

		<NodePath :node="node" />
		<span class="operator">{{ node.readableOperator }}</span>
		<span class="value">{{ node.readableValue }}</span>
	</div>
</template>

<script>
import NodePath from "./NodePath";

export default {
	components: { NodePath },

	props: {
		node: {
			type: Object,
			required: true,
		},
		isFirst: {
			type: Boolean,
			default: false,
		},
		bool: {
			type: String,
			required: true,
		},
	},
};
</script>
